import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import { FaUsers, FaBox, FaDollarSign, FaChartLine } from "react-icons/fa";

export default function Home() {
  // Sample data
  const trafficData = [
    { name: "Mon", visitors: 400 },
    { name: "Tue", visitors: 300 },
    { name: "Wed", visitors: 500 },
    { name: "Thu", visitors: 200 },
    { name: "Fri", visitors: 600 },
    { name: "Sat", visitors: 800 },
    { name: "Sun", visitors: 700 },
  ];

  const revenueData = [
    { name: "Jan", revenue: 4000 },
    { name: "Feb", revenue: 3000 },
    { name: "Mar", revenue: 5000 },
    { name: "Apr", revenue: 7000 },
    { name: "May", revenue: 6000 },
  ];

  return (
    <div className="space-y-6">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white p-4 rounded-lg shadow flex items-center gap-4">
          <FaUsers className="text-blue-500 text-3xl" />
          <div>
            <h2 className="text-lg font-bold">1,245</h2>
            <p className="text-gray-500 text-sm">Users</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow flex items-center gap-4">
          <FaBox className="text-green-500 text-3xl" />
          <div>
            <h2 className="text-lg font-bold">320</h2>
            <p className="text-gray-500 text-sm">Products</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow flex items-center gap-4">
          <FaDollarSign className="text-yellow-500 text-3xl" />
          <div>
            <h2 className="text-lg font-bold">$12,450</h2>
            <p className="text-gray-500 text-sm">Revenue</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow flex items-center gap-4">
          <FaChartLine className="text-red-500 text-3xl" />
          <div>
            <h2 className="text-lg font-bold">18%</h2>
            <p className="text-gray-500 text-sm">Growth</p>
          </div>
        </div>
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Traffic Chart */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-bold mb-4">Website Traffic</h2>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={trafficData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="visitors" stroke="#3b82f6" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Revenue Chart */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-bold mb-4">Monthly Revenue</h2>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={revenueData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="revenue" fill="#10b981" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white p-6 rounded-lg shadow">
        <h2 className="text-lg font-bold mb-4">Recent Activity</h2>
        <ul className="space-y-3">
          <li className="flex justify-between text-gray-700">
            <span>User John registered</span>
            <span className="text-sm text-gray-500">2 mins ago</span>
          </li>
          <li className="flex justify-between text-gray-700">
            <span>Order #1023 placed</span>
            <span className="text-sm text-gray-500">10 mins ago</span>
          </li>
          <li className="flex justify-between text-gray-700">
            <span>Product "Laptop" added</span>
            <span className="text-sm text-gray-500">30 mins ago</span>
          </li>
        </ul>
      </div>
    </div>
  );
}
